import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useAccommodationRequestTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
